import firebase from 'firebase/app';
import 'firebase/firestore';
import  'firebase/analytics';
import 'firebase/messaging';
import 'firebase/auth';


var firebaseApp = firebase.initializeApp({
	// Your web app's Firebase configuration
    // For Firebase JS SDK v7.20.0 and later, measurementId is optional

    apiKey: "AIzaSyBiPnaoXXQf99qV5mtBzbyNUPOb4DrFN9Y",
    authDomain: "habitprompt-aedfc.firebaseapp.com",
    projectId: "habitprompt-aedfc",
    storageBucket: "habitprompt-aedfc.appspot.com",
    messagingSenderId: "800251995829",
    appId: "1:800251995829:web:0ef48b10b5ec55f50e40fc",
    measurementId: "G-TEZVC4D8FD"
  },
);

var analytics = firebaseApp.analytics();

var db = firebaseApp.firestore();

var messaging = firebaseApp.messaging();

var firebaseAuth = firebaseApp.auth();

export { analytics, db, messaging, firebaseAuth};



//Notes: 
//firebase.analytics().logEvent('notification_received');
//https://firebase.google.com/docs/analytics/events?platform=web&authuser=0

